<template>
  <div class="container">
    <loading-wrap :loading="loading">
      <div class="row justify-content-center pt-5">
        <div class="col-8">
          <div class="d-flex justify-content-between mb-3">
            <button type="button" @click="addCategory()" class="btn btn-primary">
              <span>Add Question Category</span>
            </button>
            <button type="button" @click="addTemplate()" class="btn btn-success">
              <span>Add Template</span>
            </button>
          </div>
          <hr />
          <h4>Templates</h4>
          <template v-if="templates.length">
            <template-card
              @duplicate="duplicate"
              v-for="t in templates"
              :template="t"
              :key="t._id"
            />
          </template>
          <no-results v-else />
        </div>
      </div>
    </loading-wrap>
  </div>
</template>

<script>
export default {
  data() {
    return {
      templates: [],
      loading: true
    };
  },
  created() {
    this.creating();
  },
  methods: {
    creating() {
      this.axios.get("/api/templates").then(res => {
        this.templates = res.data;
        this.loading = false;
      });
    },
    duplicate(template) {
      this.loading = true;
      const duplicate = { ...template, name: `${template.name} (Duplicate)` };
      delete duplicate._id;

      this.axios.post("/api/templates", duplicate).finally(() => {
        this.creating();
      });
    },
    addCategory() {
      this.$root.$emit("bv::show::modal", "modal-add-category");
    },
    addTemplate() {
      this.$router.push("/dashboard/templates/add");
    }
  }
};
</script>
